const strings = {
  subject: 'Assunto',
}

export default strings
